module.exports = __webpack_public_path__ + "static/media/p4.e0269f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p4.png
// module id = 274
// module chunks = 0